import React, { useState, useEffect } from "react";
import CustomFilters from "../../core/custom-filters";
import SiAutocomplete from "../../core/si-autocomplete";
import { HTTP_METHODS, plainApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { monthOptions } from "../../pages/oem/training/training-report/helper";
import { generateYearList } from "./config";
import { PAGE_LIMIT } from "../../utils";

const PerformerFilters = ({ loadData, setMainFilters, filter }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [userList, setUserList] = useState([]);
  let userTimeout = null;

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (typeof filters[key] === "object" && filters[key]?.value) {
          if (key === "month") {
            payload[key] = filters[key].value?.toUpperCase();
          } else {
            payload[key] = filters[key].value;
          }
        } else {
          payload[key] = filters[key];
        }
      }
      if (setMainFilters) {
        setMainFilters(payload);
      }
      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    } else {
      if (setMainFilters) {
        setMainFilters({});
      }
      loadData({
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: filter?.page || 1,
      });
    }
  };

  const filterTypes = [
    { label: "Filter by Month", value: "month" },
    { label: "Filter by Year", value: "year" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "month":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={monthOptions}
            placeholder="Search Month"
          />
        );
      case "year":
        return (
          <SiAutocomplete
            onChange={setFilterValue}
            options={generateYearList()}
            placeholder="Search Year"
          />
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default PerformerFilters;
